(function($) {
    $(document).ready(function() {

        /*
         * set all favorites of the user as selected
         */
        $( document ).on( "wpgu-set-favorites-selected", function() {
            if( $('[data-wpgu-favorite-btn]').length ) {
                var favorite_posts = $( 'body' ).data( 'wpgu-favorite-posts' );

                $.each( favorite_posts, function( index, value ) {
                    $( '[data-wpgu-favorite-id="' + value + '"]' ).each( function() {
                        if( !$( this ).hasClass( 'selected' ) ) {
                            $( this ).addClass( 'selected' );
                        }
                    });
                });

                $( document ).trigger( "wpgu-favorites-marked-selected" );
            }
        });


        /*
        * Update the favorite ids
        */
        $.ajax( {
            url      : wpguvars.ajaxurl,
            data     : {
                action  : 'wpgu_get_account_info',
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( result ) {
            if(  true !== result.success ) {
                return;
            }

            if( result.data.favorite_ids && $.isArray( result.data.favorite_ids ) ) {
                $('body').data( 'wpgu-favorite-posts', result.data.favorite_ids );
                $(document).trigger( "wpgu-set-favorites-selected" );
            }

            if (result.data.bc_data) {
                $('body').append(result.data.bc_data);
            }
            /*
            let dldata = {
                'event': 'user_status', 
                'user_type': result.data.logged_in ? 'logged_in' : 'not_logged_in', //hier moet de status komen (logged_in / not_logged_in)
                'subscription_current': result.data.subscription ? result.data.subscription : 'zonder abonnement',  //kan hier de naam van het abonnement komen.
                'subscription_enddate': result.data.subscription_enddate ? result.data.subscription_enddate : 'geen'
            };


            if (result.data.nawnr) {
                dldata.subscription_id = result.data.nawnr; 
            }

            window.dataLayer = window.dataLayer || [];
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push(dldata);
            });
            */
        } );



        /*
        * Add/Remove post to favorite list using AJAX
        */
        $( 'body' ).on( 'click', '[data-wpgu-favorite-btn]', function( e ) {
            e.preventDefault();

            var $fav_button = $(this);
            var id          = $fav_button.data( 'wpgu-favorite-id' );
            var label       = $fav_button.data( 'wpgu-favorite-label' );
            var toggled     = $fav_button.data( 'wpgu-favorite-toggled' );

            if( toggled == true ) {
                return false;
            }

            $fav_button.data('wpgu-favorite-toggled', true);

            $('[data-wpgu-favorite-id="' + id + '"]').toggleClass( 'selected' );
            $(document).trigger('wpgu-favorite-btn-clicked', [$fav_button]);

            $.ajax( {
                url      : wpguvars.ajaxurl,
                data     : {
                    action  : 'wpgu_toggle_favorite',
                    post_id : id
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( result ) {

                $fav_button.data( 'wpgu-favorite-toggled', false );

                if (result.data.favorite_added) {
                    $(document).trigger("wpgu-favorite-added", [id]);
                }

                if (result.data.favorite_removed) {
                    $(document).trigger("wpgu-favorite-removed", [id]);
                }

                if( result.data.modal ) {
                    // remove the popup if it already exists
                    if( $('#' + result.data.modal_id).length ) {
                        $('#' + result.data.modal_id).remove();
                    }

                    // add modal to body
                    $( 'body' ).append( result.data.modal );
                    $('#' + result.data.modal_id).modal();

                    if( true !== result.data.logged_in ) {
                        wpguGtmTrackEvent('wpgu-favorite-button', 'not logged in click', label);
                    } else if( !result.data.nawnr ) {
                        wpguGtmTrackEvent('wpgu-favorite-button', 'not subscriber click', label);
                    } else if( true !== result.data.has_subscription_access ) {
                        wpguGtmTrackEvent('wpgu-favorite-button', 'old subscriber click', label);
                    }

                    // unselect the favorite buttons
                    $('[data-wpgu-favorite-id="' + id + '"]').toggleClass( 'selected' );

                    return;
                }

                if(result.data.toaster) {
                    // remove the toaster if it already exists
                    if( $('#' + result.data.toaster_id).length ) {
                        $('#' + result.data.toaster_id).remove();
                    }

                    // add toaster to body
                    $('body').append(result.data.toaster);
                    $('#' + result.data.toaster_id).toast('show');
                }

                if( result.data.favorite_ids ) {
                    $('body').data('wpgu-favorite-posts', result.data.favorite_ids);
                }

                if( result.data.favorite_removed ) {
                    if( $( '[data-wpgu-favorite-posts-container]' ).length ) {
                        if( $( '[data-wpgu-favorite-posts-container]' ).find( '[data-wpgu-favorite-post="' + result.data.favorite_removed + '"]' ).length ) {
                            $( '[data-wpgu-favorite-posts-container]' ).find( '[data-wpgu-favorite-post="' + result.data.favorite_removed + '"]' ).remove();
                            $( document ).trigger( "wpgu-set-favorites-selected" );

                            if( $( 'a[data-wpgu-favorite-load-more]' ).length ) {
                                $( 'a[data-wpgu-favorite-load-more]' ).data( 'offset', $( 'a[data-wpgu-favorite-load-more]' ).data( 'offset' ) - 1 );
                            }
                        }
                    }

                    wpguGtmTrackEvent( 'wpgu-favorite-button', 'removed favorite post', label );
                }

                if( result.data.favorite_added && result.data.favorite_added_html ) {
                    if( $( '[data-wpgu-favorite-posts-container]' ).length ) {
                        $( '[data-wpgu-favorite-posts-container]' ).prepend( result.data.favorite_added_html );
                        $( document ).trigger( "wpgu-set-favorites-selected" );

                        if( $( 'a[data-wpgu-favorite-load-more]' ).length ) {
                            $( 'a[data-wpgu-favorite-load-more]' ).data( 'offset', $( 'a[data-wpgu-favorite-load-more]' ).data( 'offset' ) + 1 );
                        }
                    }

                    wpguGtmTrackEvent( 'wpgu-favorite-button', 'added favorite post', label );
                }

            } );
        });



        /*
        * Load more favorite items using AJAX
        */
        $( document ).on( 'click', 'a[data-wpgu-favorite-load-more]', function ( event ) {
            event.preventDefault();

            if( !$( '[data-wpgu-favorite-load-more-target]' ).length ) {
                console.warn( 'Load more target not found' );
                return false;
            }

            if ( $( '[data-wpgu-loading-icon]' ).length ) {
                return false;
            }

            var $button      = $(event.target),
                loadingtxt   = $button.data( 'loadingtxt' ),
                normaltxt    = $button.text(),
                title        = $button.attr( 'title' ),
                offset       = $button.data( 'offset' ),
                amount       = $button.data( 'amount' );

            $button.html( loadingtxt );
            $button.removeClass( 'has-error' );
            $button.addClass( 'is-loading' );

            $.ajax( {
                url      : wpguvars.ajaxurl,
                data     : {
                    action: 'wpgu_load_more_favorite_items',
                    post_id: wpguvars.post_id,
                    offset: offset,
                    amount: amount,
                    title: title
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {

                $button.text( normaltxt );
                $button.removeClass( 'is-loading' );

                if ( true !== response.success || 0 === response.data.posts_total ) {
                    $button.addClass( 'has-error' );
                    console.warn( 'No posts found' );
                    return;
                }

                $( '[data-wpgu-favorite-load-more-target]' ).append( response.data.posts );

                var newoffset = offset + amount;
                if( typeof $button.data( 'offset' ) !== 'undefined' ) {
                    $button.data( 'offset', newoffset );
                }

                if( newoffset >= parseInt( response.data.posts_total ) ) {
                    $( '[data-wpgu-favorite-load-more-container]' ).html("");
                }

                $( document ).trigger( "wpgu-set-favorites-selected" );
            });
        });


        /*
        * On click send event to GTM
        */
        $( document ).on( 'click', 'a[data-wpgu-ga-category]', function ( event ) {
            var category = $(this).data('wpgu-ga-category');
            var action = $(this).data('wpgu-ga-action');
            var label = $(this).data('wpgu-ga-label');

            wpguGtmTrackEvent(category, action, label);
        });


        /**
         * Function to switch between tabs
         */
        /*
        $('.tabs .tabs-choice').click(function() {
            $(this).closest('.tabs').find('.tabs-choice').removeClass('active');
            $(this).closest('.tabs').find('.tabs-tab').hide();
            $('#'+$(this).data('id')).show();
            $(this).addClass('active');
        });
        *\


        /**
         * Function to set handle the navigation through the steps
         */
        $(document).on('click', '[data-wpgu-step-goto]', function(e) {
            e.preventDefault();
            
            var current = $(this).data('wpgu-step-current');
            var goto    = $(this).data('wpgu-step-goto');
    
            $('#wpgu-onboarding-step-' + goto).removeClass('wpgu-slide-out-left');
            $('#wpgu-onboarding-step-' + goto).removeClass('wpgu-slide-out-right');
            $('#wpgu-onboarding-step-' + goto).removeClass('wpgu-step-default');
    
            $('#wpgu-onboarding-step-' + current).removeClass('wpgu-step-active');
            $('#wpgu-onboarding-step-' + current).removeClass('wpgu-slide-in-left');
            $('#wpgu-onboarding-step-' + current).removeClass('wpgu-slide-in-right');
    
            if (current < goto) {
                $('#wpgu-onboarding-step-' + current).addClass('wpgu-slide-out-left');
                $('#wpgu-onboarding-step-' + current).addClass('wpgu-slided-out');
                $('#wpgu-onboarding-step-' + goto).addClass('wpgu-slide-in-right');
            } else {
                $('#wpgu-onboarding-step-' + current).addClass('wpgu-slide-out-right');
                $('#wpgu-onboarding-step-' + current).removeClass('wpgu-slided-out');
                $('#wpgu-onboarding-step-' + goto).addClass('wpgu-slide-in-left');
            }
    
            $('#wpgu-onboarding-step-' + goto).addClass('wpgu-step-active');
    
            // update progress bar
            if ($('[data-wpgu-progress]').length) {
                var steps = $('[data-wpgu-progress]').data('wpgu-progress-steps');
                var progress_width = (100 / steps) * goto;
                $('[data-wpgu-progress]').width(progress_width + '%');
    
                if (goto === 1) {
                    $('[data-wpgu-progress]').addClass('wpgu-onboarding-progress-hide');
                } else {
                    $('[data-wpgu-progress]').removeClass('wpgu-onboarding-progress-hide');
                }
            }
    
            if(!$(this).hasClass('wpgu-onboarding-step-back') && !$(this).hasClass('wpgu-onboarding-step-skip')) {
                saveOnboardingData(current);
            }
        });


        /**
         * Set a cookie to hide the popup or cta block for a set amount of time
         */
        $(document).on('click', '[data-wpgu-onboarding-close]', function(e) {
            e.preventDefault();
            
            var go_to_url = $(this).attr('href');

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'wpgu_set_onboarding_close_cookie',
                },
                type: 'POST',
                dataType: 'json',
                success: function (data) {
                    if (go_to_url) {
                        window.location.replace(go_to_url);
                    }
                }
            });
        });
    

        /**
         * Save the onboarding data in the final step and then redirect to end_url
         */
        $('#submit-onboarding').on('click', function(e) {
            e.preventDefault();
    
            var current = $(this).data('wpgu-step-current');
            $(this).addClass('saving');
    
            saveOnboardingData(current, true);
        });
    
    
        /**
         * save the onboarding data in the database with an ajax call
         */
        function saveOnboardingData(current = 0, end = false) {

            if(current === 0) {
                return;
            }
    
            var post_data = {};
            var form_data = $('#wpgu-onboarding-form').serializeArray();
            
            for (var i = 0; i < form_data.length; i++) {
                if (form_data[i]['name'].endsWith('[]')) {
                    var name = form_data[i]['name'];
                    name = name.substring(0, name.length - 2);
                    if (!(name in post_data)) {
                        post_data[name] = [];
                    }
                    post_data[name].push(form_data[i]['value']);
                } else {
                    post_data[form_data[i]['name']] = form_data[i]['value'];
                }
            }
    
            $.ajax( {
                url      : wpguvars.ajaxurl,
                data     : {
                    action: 'wpgu_save_onboarding_data',
                    post_id: wpguvars.post_id,
                    step_current: current,
                    post_data: post_data,
                    end: end
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( response ) {
                $( document ).trigger( "wpgu-onboarding-saved" );
    
                if (response.data.end_url) {
                    window.location.replace(response.data.end_url);
                }
            });
        }
    }); // close DOM ready


    // send event data to GTM
    function wpguGtmTrackEvent( category, action, label ) {
        if( !window.dataLayer ) {
            return;
        }

        var event = {
            'event': 'TrackEvent',
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label
        };

        try {
            dataLayer.push(event);
        } catch (e) {
            console.log(e);
        }
    }


})(jQuery);
